<template>
  <div class="w-full h-full p-4">
    <div class="w-full h-full relative">
      <div class="w-full h-full absolute bg-white rounded-content-lg"></div>
      <div
        class="relative w-full h-full flex flex-col justify-between items-center p-8"
      >
        <div class="flex justify-between w-full items-center">
          <div class="flex gap-2 items-center">
            <div class="w-12 h-12">
              <img src="/images/logo.png" class="w-full h-full" alt="" />
            </div>
            <div>EkiDiscount</div>
          </div>
          <!-- <div class="text-right text-sm md:text-base">
            <span class="text-[#959496]"> Vous n'avez pas de compte ? </span>
            <br class="md:hidden" />
            <router-link to="/register" class="font-bold text-primary">
              Créer un compte
            </router-link>
          </div> -->
        </div>
        <div class="md:w-[35rem]">
          <div class="text-3xl md:text-4xl font-bold title-color">
            Ekidiscount Admin
          </div>
          <div class="py-1"></div>
          <div class="text-[#959496]">
            Connectez vous
          </div>
          <div class="py-4"></div>
          <div>
            <FormComponent
              class="w-full grid grid-cols-12 gap-x-4"
              :fields="fields"
              :onFormSubmited="
                data => {
                  requestLogin(data)
                }
              "
              :loading="false"
              ref="form"
            >
              <template #submitButton>
                <button class="hidden" type="submit" ref="submit"></button>
              </template>
            </FormComponent>
          </div>
          <!-- <div class="justify-end flex text-primary -mt-5">
            <button @click="resetPassword">Mot de passe oublié ?</button>
          </div> -->
          <div class="py-4"></div>
          <div class="w-full">
            <button @click="$refs.submit.click" class="buttonComponent w-full">
              Connexion
            </button>
          </div>
        </div>
        <div class="text-center text-[#959496]">
          &copy; 2025. Tous droits réservés.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormComponent from '../utils/FormComponent.vue'

export default {
  components: { FormComponent },
  data() {
    return {
      fields: [
        {
          type: 'email',
          propertyName: 'email',
          label: 'Email',
          placeHolder: 'Entrez votre email',
          defaultValue: '',
          required: true,
          class: 'col-span-12',
        },
        {
          type: 'password',
          propertyName: 'password',
          label: 'Mot de passe',
          placeHolder: 'Entrez votre mot de passe',
          defaultValue: '',
          required: true,
          class: 'col-span-12',
        },
      ],
      eventsIds: [],
      userCountry: {},
      loading: false,
      accountId: '',
    }
  },
  mounted() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    const id = this.$Events.handleEvent('login_done', this.onLoginDone)
    const id2 = this.$Events.handleEvent('login_failed', this.onLoginFailed)
    this.eventsIds.push(id)
    this.eventsIds.push(id2)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    async resetPassword() {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: 'Réinitialisation de mot de passe',
          subTitle: "Veuillez entrer l'email de votre compte",
          formFields: [
            {
              type: 'email',
              propertyName: 'email',
              label: 'Email de votre compte',
              defaultValue: '',
              required: true,
            },
          ],
          successText: 'Réinitialiser',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Demande acceptée',
        body:
          "Vous recevrez un mail de réinitialisation sur l'adresse " +
          prompt.data.email,
      })
    },
    requestLogin(data) {
      if (this.loading) return
      this.loading = true
      this.$Events.dispatchEvent('start_loading', { title: 'Connexion' })
      this.$Events.dispatchEvent('login_requested', {
        ...data,
        // phoneNumber: this.accountId,
        // password: data.password,
      })
    },
    async onLoginDone() {
      this.loading = false
      // this.$Events.dispatchEvent('finish_loading')
      await new Promise(r => setTimeout(r, 500))
      this.$router.push('/home')
      // window.location.reload();
    },
    onLoginFailed(data) {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        type: 'warning',
        title: this.$t('login.loginFailedTitle'),
        body:
          this.$t(data.messageId) || this.$t('login.loginFailedDefaultMessage'),
      })
      this.loading = false
      this.enterPassword = false
    },
    loginWithGoogle() {
      this.$Events.dispatchEvent('login_with_google_required')
    },
  },
}
</script>
